import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader-desk-menu',
  templateUrl: './loader-desk-menu.component.html',
  styleUrls: ['./loader-desk-menu.component.css']
})
export class LoaderDeskMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/loaders/loader-desk-menu/loader-desk-menu.component.ts